export default function FortuneGemsRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    h1{
                        font-size: 40px;
                        font-weight: 800;
                    }
                    h3 {
                        font-size: 28px;
                    }
                    p{
                        font-size: 15px;
                        font-weight: 500;
                    }    
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100% !important;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 800px;
                        max-height: calc(100vh - 40px);
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                    #market-rules-text ol {
                        list-style-type: decimal;
                        padding-left: 40px;
                    }
                    #market-rules-text ol li {
                        list-style: list-item !important;
                    }
                    .modal-overlay {
                        position: fixed; 
                        top: 0;
                        left: 0;
                        width: 100vw;
                        height: 100vh;
                        background: rgba(0, 0, 0, 0.5);
                        display: flex;
                        justify-content: center;
                        align-items: flex-start;
                        z-index: 9999;
                        overflow-y: auto;
                        }
                        .slots-rules {
                                font - family: -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
                            color: #111;
                            margin: 0;
    }

                            .slots-rules .wrap {
                                max - width: 900px;
                            margin: 0 auto;
                            padding: 24px;
    }

                            .slots-rules h1,
                            .slots-rules h2,
                            .slots-rules h3 {
                                text - align: center;
                            margin: 0.2rem 0;
    }

                            .slots-rules hr {
                                border: 0;
                            height: 1px;
                            background: #e2e2e2;
                            margin: 16px 0 24px;
    }

                            .slots-rules .pt20 {
                                color: black !important;
                            font-size: 15px !important;
    }

                            .slots-rules .lit20 {
                                line - height: 1.9rem !important;
    }

                            .slots-rules .section {
                                margin: 22px 0;
    }

                            .slots-rules .card {
                                background: #fff;
                            border: 1px solid #eee;
                            border-radius: 8px;
                            padding: 16px;
                            box-shadow: 0 2px 8px rgba(0,0,0,0.04);
    }

                            .slots-rules table {
                                width: 100%;
                            border-collapse: collapse;
                            margin: 8px 0;
    }

                            .slots-rules th,
                            .slots-rules td {
                                border: 1px solid #ddd;
                            padding: 8px 10px;
                            text-align: left;
    }

                            .slots-rules thead th {
                                background: #f9fafb;
    }

                            .slots-rules .small {
                                font - size: 12px;
                            color: #555;
    }

                            .slots-rules .grid-note {
                                font - family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
                            background: #fafafa;
                            border: 1px dashed #ddd;
                            padding: 10px;
                            border-radius: 8px;
    }
                            /* Payline mini diagrams */
                            .slots-rules .pl {
                                display: grid;
                            grid-template-columns: repeat(3, 18px);
                            grid-auto-rows: 18px;
                            gap: 2px;
    }

                            .slots-rules .pl .cell {
                                width: 18px;
                            height: 18px;
                            border: 1px solid #bbb;
                            border-radius: 3px;
                            background: #fff;
        }

                            .slots-rules .pl .hit {
                                background: #4caf5022;
                            border-color: #4caf50;
        }

                            .slots-rules .pl-label {
                                font - size: 13px;
                            color: #333;
                            margin-top: 6px;
                            text-align: center;
    }

                            .slots-rules .pl-wrap {
                                display: flex;
                            gap: 16px;
                            flex-wrap: wrap;
                            justify-content: center;
    }

                            .slots-rules .pl-card {
                                display: flex;
                            flex-direction: column;
                            align-items: center;
                            padding: 8px;
                            border: 1px solid #eee;
                            border-radius: 8px;
    }

                            .slots-rules .muted {
                                color: #666;
    }
                `}
            </style>
            {show && (
                <div className="modal-overlay">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div class="slots-rules wrap">
                                <h1 style={{ textAlign: "center" }}><b>Fortune Gems Slots</b></h1>
                                <h2 style={{ textAlign: "center" }}>Rules &amp; Instructions</h2>
                                <hr></hr>
                                <div class="section card">
                                    <h3 style={{ textAlign: "center" }}><b>Game Objective</b></h3>
                                    <p class="pt20">
                                        Spin the reels and match symbols along active paylines. Wins are awarded for
                                        <b>3-of-a-kind</b> or for an <b>adjacent 2-of-a-kind</b> (columns 1–2 or 2–3) on a payline.
                                        Only the <b>highest single outcome per line</b> is paid. Multiple lines can win on the same spin.
                                    </p>
                                </div>


                                <div class="section card">
                                    <h3 style={{ textAlign: "center" }}><b>Paylines</b></h3>
                                    <p class="pt20">There are <b>5 paylines</b>. Left-to-right evaluation applies to all lines.</p>
                                    <div class="pl-wrap">

                                        <div class="pl-card">
                                            <div class="pl">
                                                <div class="cell"></div><div class="cell"></div><div class="cell"></div>
                                                <div class="cell hit"></div><div class="cell hit"></div><div class="cell hit"></div>
                                                <div class="cell"></div><div class="cell"></div><div class="cell"></div>
                                            </div>
                                            <div class="pl-label">1) Middle</div>
                                        </div>

                                        <div class="pl-card">
                                            <div class="pl">
                                                <div class="cell hit"></div><div class="cell hit"></div><div class="cell hit"></div>
                                                <div class="cell"></div><div class="cell"></div><div class="cell"></div>
                                                <div class="cell"></div><div class="cell"></div><div class="cell"></div>
                                            </div>
                                            <div class="pl-label">2) Top</div>
                                        </div>
                                        <div class="pl-card">
                                            <div class="pl">
                                                <div class="cell"></div><div class="cell"></div><div class="cell"></div>
                                                <div class="cell"></div><div class="cell"></div><div class="cell"></div>
                                                <div class="cell hit"></div><div class="cell hit"></div><div class="cell hit"></div>
                                            </div>
                                            <div class="pl-label">3) Bottom</div>
                                        </div>
                                        <div class="pl-card">
                                            <div class="pl">
                                                <div class="cell hit"></div><div class="cell"></div><div class="cell"></div>
                                                <div class="cell"></div><div class="cell hit"></div><div class="cell"></div>
                                                <div class="cell"></div><div class="cell"></div><div class="cell hit"></div>
                                            </div>
                                            <div class="pl-label">4) DiagonalDown (\)</div>
                                        </div>
                                        <div class="pl-card">
                                            <div class="pl">
                                                <div class="cell"></div><div class="cell"></div><div class="cell hit"></div>
                                                <div class="cell"></div><div class="cell hit"></div><div class="cell"></div>
                                                <div class="cell hit"></div><div class="cell"></div><div class="cell"></div>
                                            </div>
                                            <div class="pl-label">5) DiagonalUp (/)</div>
                                        </div>
                                    </div>
                                    <p class="small">Enable/disable paylines in the UI; total bet is split on the number of active lines.</p>
                                </div>

                                <div class="section card">
                                    <h3 style={{ textAlign: "center" }}><b>Payouts</b></h3>
                                    <p class="pt20">Multipliers are applied <b>per active line</b> to your <b>bet per line</b>. For each line, only the single highest outcome is paid (Triple beats Pair).</p>
                                    <table>
                                        <thead>
                                            <tr><th>Symbol</th><th>3-of-a-Kind</th><th>Adjacent Pair (1–2 or 2–3)</th><th>Notes</th></tr>
                                        </thead>
                                        <tbody>
                                            <tr><td>J</td>    <td>3×</td><td>1×</td><td class="muted">Common</td></tr>
                                            <tr><td>Q</td>     <td>4×</td><td>1×</td><td class="muted">Common</td></tr>
                                            <tr><td>K</td>      <td>7×</td><td>1×</td><td class="muted">Uncommon</td></tr>
                                            <tr><td>A</td>       <td>12×</td><td>3×</td><td class="muted">Uncommon</td></tr>
                                            <tr><td>Red</td> <td>24×</td><td>4×</td><td class="muted">Rare</td></tr>
                                            <tr><td>Blue</td>     <td>50×</td><td>6×</td><td class="muted">Very Rare</td></tr>
                                            <tr><td>Green</td>   <td>100×</td><td>7×</td> <td class="muted">Ultra Rare</td></tr>
                                        </tbody>
                                    </table>
                                    <ul>
                                        <li class="lit20">Pairs pay only when matching symbols are adjacent on columns (1–2) or (2–3) along the line.</li>
                                        <li class="lit20">If both pairs exist (which only occurs in a triple), the triple payout applies.</li>
                                        <li class="lit20">Total spin payout = <b>bet per line × (sum of multipliers across active lines)</b>.</li>
                                    </ul>
                                </div>
                                <div class="section card">
                                    <h3 style={{ textAlign: "center" }}><b>Betting &amp; Game Flow</b></h3>
                                    <ol>
                                        <li class="lit20">Choose your <b>bet per line</b> and select which paylines to activate.</li>
                                        <li class="lit20">Spin the reels. A 3×3 grid of symbols appears.</li>
                                        <li class="lit20">Wins are evaluated left-to-right on each active line and paid according to the table above.</li>
                                        <li class="lit20">Winnings are credited at the end of the round.</li>
                                    </ol>
                                </div>

                                <p class="small muted" style={{ textAlign: "center", marginTop: "18px" }}>
                                    Version 1.2 — Updated:27 Sep 2025
                                </p>
                            </div>

                        </div>
                    </div>


                </div>
            )}
        </>
    );
}